import type { ComponentProps } from 'react'
import { useCallback } from 'react'

import type { ManagedField } from '@/modules/message/components/editor/fields/managed-field'
import type { MediaSelection } from '@/modules/message/components/editor/fields/message-media-dropdown'
import { MessageMediaDropdown } from '@/modules/message/components/editor/fields/message-media-dropdown'
import { classNames } from '@/utils/helpers'

export type MessageMediaSelectorProps = ComponentProps<'div'> & {
  field: ManagedField<MediaSelection[]>
}

export const MessageMediaSelector = (props: MessageMediaSelectorProps) => {
  const { className, field, ...rest } = props
  const handleSelect = useCallback(
    (options: MediaSelection[]) => {
      field.onChange({ target: { value: options } })
    },
    [field],
  )

  return (
    <div
      {...rest}
      className={classNames('flex flex-col gap-1.5', className)}
    >
      <label className="flex items-center gap-2 text-sm font-medium text-text-default">
        Media
      </label>
      <MessageMediaDropdown
        selected={field.value ?? []}
        onSelect={handleSelect}
      />
    </div>
  )
}
